module.exports = __webpack_public_path__ + "img/card-upgrade.7fafea22.svg";